import GoogleMap, { type GoogleMapsProps } from "components/GoogleMap/googlemap";
import React from "react";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";

interface Props extends GoogleMapsProps {
  height: number
  googleDirectionsStatus: string
  hexColor: string
  polyline: string
  start: server.dto.GroundTransportStartEnd
  end: server.dto.GroundTransportStartEnd
}

const formatTooltip = (place: server.dto.GroundTransportStartEnd) => {
  return `<div style="font-size: 14px; font-weight: 500">${place.placeName}</div>` +
    `<div style="font-size: 14px; font-weight: 400">${place.placeAddress}</div>`;
}

export const GoogleMapRoute = (props: Props) => {
  const {
    height,
    googleDirectionsStatus,
    hexColor,
    polyline,
    start,
    end,
    ...rest
  } = props;

  if (googleDirectionsStatus !== "OK") {
    return <div className="flex align-center justify-center s1_gray gray-100" style={{ height }}>
      <div style={{ textAlign: "center" }}>
        <h1>{RESX.Map.CannotFindAddressOnMap}</h1>
        <div className="margin-top">
          <SupportQuestionMark articleId={serverReference.supportArticleIds.cannotFindAddressOnMap} />
        </div>
      </div>
    </div>
  }

  const startInfoWindow = new google.maps.InfoWindow({
    content: formatTooltip(start),
  });

  const endInfoWindow = new google.maps.InfoWindow({
    content: formatTooltip(end),
  });

  return <div style={{ height, minHeight: height }}>
    <GoogleMap
      autoFitBounds
      polylines={[{
        id: "route",
        polyline,
        hexColor,
      }]}
      coordinates={[{
        position: { lat: start.placeGeo[0], lng: start.placeGeo[1] },
        pin: {
          type: "groundTransport",
          content: "A",
        },
        clickable: true,
        onLoaded(_, marker) {
          marker.addListener("click", () => {
            startInfoWindow.open(marker.map, marker as any);
          });
        },
      }, {
        position: { lat: end.placeGeo[0], lng: end.placeGeo[1] },
        pin: {
          type: "groundTransport",
          content: "B",
        },
        clickable: true,
        onLoaded(_, marker) {
          marker.addListener("click", () => {
            endInfoWindow.open(marker.map, marker as any);
          });
        },
      }]}
      mapOptions={{
        center: {
          lat: (start.placeGeo[0] + end.placeGeo[0]) / 2,
          lng: (start.placeGeo[1] + end.placeGeo[1]) / 2
        },
        zoom: 10,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControl: false,
        mapTypeControl: false,
      }}
      {...rest}
    />
  </div>
}